import React, { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";

import CustomizedDialogs from "../details";
import useBoardIdByKey from "../../../../hooks/useBoardIdByKey";

const OpenCardDetail = ({ cardsOnBoard = [] ,card}) => {
  const [showDetails, setShowDetails] = useState(true);
  const [searchParams] = useSearchParams();
  const { id } = useBoardIdByKey();
  const cardId = searchParams.get("card_id") || card;

  useEffect(() => {
    if (cardId) {
      setShowDetails(true);
    } else {
      setShowDetails(false);
    }
  }, [cardId]);

  return (
    <div>
      {cardId && cardsOnBoard && (
        <CustomizedDialogs
          cardId={cardId}
          boardId={id}
          cardsOfSameWorkflowStepId={cardsOnBoard}
          showDetails={showDetails}
          setShowDetails={setShowDetails}
        />
      )}
    </div>
  );
};

export default OpenCardDetail;
